<script>
import UserInteraction from './UserInteraction';

export default {
    name: "SuperAdminUserInteraction",
    extends: UserInteraction,
    computed: {
        cancelBtnText() {
            return 'Cancel';
        },
        closeBtnText() {
            return 'Close';
        }
    },
    methods: {
        handleDescription() {
            return this.passedProps.description;
        }
    }
}
</script>